module.exports = __webpack_public_path__ + "static/media/icon-card-active.f86d69bf.svg";